import { ApolloError, ServerError } from "@apollo/client";
import { errorNotification } from "../variables/notification";

export const handleApolloError = (error: ApolloError) => {
  const isOffline =
    typeof navigator !== "undefined" && navigator.onLine === false;
  const apollo = error as ApolloError;
  const msg =
    apollo?.message ||
    error?.message ||
    (typeof error === "string" ? error : "") ||
    "";
  const netErr = apollo?.networkError as ServerError | undefined;
  const statusCode = netErr?.statusCode ?? netErr?.response?.status;

  let message;

  const errorType = getErrorType(isOffline, msg, statusCode, apollo);

  switch (errorType) {
    case "offline":
      message = "You're offline. Check your internet connection and try again.";
      break;
    case "timeout":
      message = "The request timed out. Please try again.";
      break;
    case "network":
      message = "Network error. Please check your connection and try again.";
      break;
    case "server_error":
      message = `Server error (${statusCode}). Please try again later.`;
      break;
    case "too_many_requests":
      message = "Too many requests. Please wait a moment and try again.";
      break;
    case "client_error":
      message = `Request failed (${statusCode}). Please try again.`;
      break;
    case "graphql_error":
      message = apollo.graphQLErrors[0]?.message ?? "Something went wrong";
      break;
    default:
      message = msg || "Something went wrong";
      break;
  }

  errorNotification(message);
};

function getErrorType(
  isOffline: boolean,
  msg: string,
  statusCode: number | undefined,
  apollo: ApolloError
): string {
  if (isOffline) return "offline";

  if (/timeout/i.test(msg)) return "timeout";

  if (/Failed to fetch|NetworkError|Network request failed/i.test(msg))
    return "network";

  if (typeof statusCode === "number") {
    if (statusCode >= 500) return "server_error";

    if (statusCode === 429) return "too_many_requests";

    if (statusCode >= 400) return "client_error";
  }

  if (apollo?.graphQLErrors?.length) return "graphql_error";

  return "unknown";
}
